import NavbarFr from '../components/NavbarFr';
import FooterFr from 'components/FooterFr';
import { useSelector } from "react-redux";
import MobileNavbarFr from 'components/MobileNavbarFr';
import HomePageFr from 'components/Home/HomePageFr';
import MobileFooterFr from 'components/MobileFooterFr';
import { useEffect } from "react";

function HomeFr() {

  const isMobile = useSelector(state => state.windowSize.isMobile);
  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <HomePageFr />
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <HomePageFr />
      <FooterFr />
      </>
    )}
    </>
  );
}

export default HomeFr;
